import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'


//设置部分
import noWxBrowser from '@/components/views/WeChat/noWxBrowser'


// 微信用户注册
import Meeting from '@/components/views/WeChat/Person/Meeting'
import EateryRecord from '@/components/views/WeChat/Person/Eatery/Record'
import EateryAttend from '@/components/views/WeChat/Person/Eatery/Attend'
import Person from '@/components/views/WeChat/Person/index_old.vue'
import Map from '@/components/views/WeChat/Map'
import Attend from '@/components/views/WeChat/Person/Meeting/Attend'
import mRegister from '@/components/views/WeChat/Person/Meeting/Register'

import Testing from '@/components/views/WeChat/Person/Testing'
import Photo from '@/components/views/WeChat/Person/Photo'
import Result from '@/components/views/WeChat/Person/Testing/Result'
import Topic from '@/components/views/WeChat/Person/Testing/Topic'
import Binding from '@/components/views/WeChat/Person/Testing/Binding'

import Register from '@/components/views/WeChat/Register'

// 账号部分
import Account from '@/components/views/WeChat/Person/Account'
import Phone from '@/components/views/WeChat/Person/Account/Phone'
import PhoneBd from '@/components/views/WeChat/Person/Account/Phone/Binding'
import IdCard from '@/components/views/WeChat/Person/Account/IdCard'
import IdCardBd from '@/components/views/WeChat/Person/Account/IdCard/Binding'
import Mail from '@/components/views/WeChat/Person/Account/Mail'


//家庭成员部分
import Family from '@/components/views/WeChat/Person/Family'

//信息部分
import Info from '@/components/views/WeChat/Person/Info'
import Address from '@/components/views/WeChat/Person/Info/Address'
import Alias from '@/components/views/WeChat/Person/Info/Alias'
import More from '@/components/views/WeChat/Person/Info/More'


//设置部分
import Setting from '@/components/views/WeChat/Person/Setting'




Vue.use(Router)

const router=new Router({
	mode: 'history',
  routes: [
    {
      path: '/mpMenu',
      name: 'HelloWorld',
      component: HelloWorld
    },
		{
				path: '/WeChat/Person',
				name: 'Person',
				meta: {
					title: '个人中心'
				},
				component: Person
			},
			// {
			// 	path: '/WeChat/Testing',
			// 	name: 'Testing',
			// 	meta: {
			// 		title: '基本公卫有奖问答'
			// 	},
			// 	component: Testing
			// },
			// {
			// 	path: '/WeChat/Photo',
			// 	name: 'Photo',
			// 	meta: {
			// 		title: '宣传知识'
			// 	},
			// 	component: Photo
			// },
			// {
			// 	path: '/WeChat/Testing/Topic',
			// 	name: 'Topic',
			// 	meta: {
			// 		title: '答题系统'
			// 	},
			// 	component: Topic
			// },
			// {
			// 	path: '/WeChat/Testing/Result',
			// 	name: 'Result',
			// 	meta: {
			// 		title: '成绩单'
			// 	},
			// 	component: Result
			// },
			// {
			// 	path: '/WeChat/Testing/Binding',
			// 	name: 'Binding',
			// 	meta: {
			// 		title: '身份绑定'
			// 	},
			// 	component: Binding
			// },
			// {
			// 	path: '/WeChat/Map',
			// 	name: 'Map',
			// 	meta: {
		 //        title: '医疗机构分布图'
		 //    },
			// 	component: Map
			// },
			// {
			// 	path: '/WeChat/Person/Meeting',
			// 	name: 'Meeting',
			// 	meta: {
		 //        title: '会议通知'
		 //    },
			// 	component: Meeting,
			// },
			// {
			// 	path:'/WeChat/Person/Meeting/Attend',
			// 	name: 'Attend',
			// 	meta: {
		 //        title: '参会处理'
		 //    },
			// 	component: Attend
			// },
			// {
			// 	path:'/WeChat/Person/Meeting/Register',
			// 	name: 'mRegister',
			// 	meta: {
		 //        title: '签到情况'
		 //    },
			// 	component: mRegister
			// },
			{
				path: '/WeChat/Person/Eatery/Record',
				name: 'EateryRecord',
				meta: {
		        title: '食堂消费情况'
				},
				component: EateryRecord
			},
			// {
			// 	path: '/WeChat/Person/Eatery/Attend',
			// 	name: 'EateryAttend',
			// 	meta: {
		 //        title: '食堂就餐报名'
			// 	},
			// 	component: EateryAttend
			// },


			// {
			// 	path: '/WeChat/Register',
			// 	name: 'Register',
			// 	meta: {
			// 		title: '用户注册'
			// 	},
			// 	component: Register
			// },



			// {
			// 	path: '/WeChat/Person/Account',
			// 	name: 'Account',
			// 	meta: {
			// 		title: '账号信息'
			// 	},
			// 	component: Account
			// },
			// {
			// 	path: '/WeChat/Person/Account/Phone',
			// 	name: 'Phone',
			// 	meta: {
			// 		title: '个人手机'
			// 	},
			// 	component: Phone
			// },
			// {
			// 	path: '/WeChat/Person/Account/Phone/Binding',
			// 	name: 'PhoneBd',
			// 	meta: {
			// 		title: '个人手机'
			// 	},
			// 	component: PhoneBd
			// },
			// {
			// 	path: '/WeChat/Person/Account/IdCard',
			// 	name: 'IdCard',
			// 	meta: {
			// 		title: '个人身份证'
			// 	},
			// 	component: IdCard
			// },
			// {
			// 	path: '/WeChat/Person/Account/IdCard/Binding',
			// 	name: 'IdCardBd',
			// 	meta: {
			// 		title: '个人身份证'
			// 	},
			// 	component: IdCardBd
			// },
			// {
			// 	path: '/WeChat/Person/Account/Mail',
			// 	name: 'Mail',
			// 	meta: {
			// 		title: '个人邮箱'
			// 	},
			// 	component: Mail
			// },



			// {
			// 	path: '/WeChat/Person/Family',
			// 	name: 'Family',
			// 	meta: {
			// 		title: '家庭成员'
			// 	},
			// 	component: Family
			// },


			// {
			// 	path: '/WeChat/Person/Info',
			// 	name: 'Info',
			// 	meta: {
			// 		title: '个人信息'
			// 	},
			// 	component: Info
			// },
			// {
			// 	path: '/WeChat/Person/Info/Address',
			// 	name: 'Address',
			// 	meta: {
			// 		title: '个人信息-我的地址'
			// 	},
			// 	component: Address
			// },
			// {
			// 	path: '/WeChat/Person/Info/Alias',
			// 	name: 'Alias',
			// 	meta: {
			// 		title: '个人信息-昵称修改'
			// 	},
			// 	component: Alias
			// },
			// {
			// 	path: '/WeChat/Person/Info/More',
			// 	name: 'More',
			// 	meta: {
			// 		title: '个人信息-更多'
			// 	},
			// 	component: More
			// },

			// {
			// 	path: '/WeChat/Person/Setting',
			// 	name: 'Setting',
			// 	meta: {
			// 		title: '设置'
			// 	},
			// 	component: Setting
			// },
			{
				path: '/noWxBrowser',
				name: 'noWxBrowser',
				meta: {
					title: '请使用微信客户端打开此链接'
				},
				component: noWxBrowser
			},
      {
      	path: '*',
      	name: 'other',
      	meta: {
      		title: '请使用微信客户端打开此链接'
      	},
      	component: noWxBrowser
      }

  ]
})


Router.prototype.isWxBrowser=function(){
	var ua = window.navigator.userAgent.toLowerCase();
	return ua.match(/MicroMessenger/i) == 'micromessenger';
}



router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if(to.path.indexOf('WeChat')!=-1&&!router.isWxBrowser()){
	  router.push('/noWxBrowser');
	  return ;
  }

  if(to.name=='Result'){

  }
  if (to.meta.title) {
      document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js